import { MaterialDTO } from '../dto/material';

export const isERP = (material: MaterialDTO) => {
  return material.userId === undefined;
};
